/**
 * Keeps `<meta name="theme-color">` in step with the active theme so the
 * browser chrome (Android's status bar, Safari's toolbar) tints live when the
 * player swaps themes mid-game. See the note on `manifest()` in `config.ts`
 * for why the *installed* manifest's colour cannot follow along the same way.
 */
export function applyThemeColorMeta(color: string, doc: Document = document): void {
  let meta = doc.querySelector('meta[name="theme-color"]');
  if (meta === null) {
    meta = doc.createElement('meta');
    meta.setAttribute('name', 'theme-color');
    doc.head.appendChild(meta);
  }
  meta.setAttribute('content', color);
}
